import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import axios from "axios";
import DOMPurify from "dompurify"; // Asegura que el HTML sea seguro

const GestionesJuridica = ({ id }) => {
  const [gestiones, setGestiones] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      axios
        .get(
          "https://contratosback-dev.azurewebsites.net/api/v1/ObtenerGestiones/" +
            id
        )
        .then((response) => {
          setGestiones(response.data);
        })
        .catch((error) => {
          console.error("Error al obtener las gestiones:", error);
        });
    }
  };

  return (
    <div className="text-center mt-4">
      <Button color="primary" onClick={toggle}>
        Ver Gestiones
      </Button>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        style={{
          width: "90%", // 90% del ancho de la pantalla
          height: "90%", // 90% de la altura de la pantalla
          maxWidth: "none",
        }}
        contentClassName="custom-modal-content" // Clase para estilos personalizados
      >
        <ModalHeader toggle={toggle}>Gestiones</ModalHeader>
        <ModalBody
          style={{
            maxHeight: "calc(100% - 120px)", // Altura máxima para el contenido
            overflowY: "auto", // Scroll interno para contenido que exceda
          }}
        >
          <Table striped>
            <thead>
              <tr>
                <th>ID Usuario</th>
                <th>Fecha Creación</th>

                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              {gestiones.length > 0 ? (
                gestiones.map((gestion) => (
                  <tr key={gestion.id}>
                    <td>{gestion.idUsuario}</td>
                    <td>
                      {new Date(gestion.fechaCreacion).toLocaleDateString()}
                    </td>
                    <td>
                      {/* Renderizar la descripción con texto enriquecido */}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(gestion.descripcion),
                        }}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No hay datos disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default GestionesJuridica;
